import styled from 'styled-components';
import { screen, spacing } from 'theme';
import { StyledAnchor } from './MethodologyAnchor.styled';

export const StyledSection = styled.div`
  padding-top: ${spacing('xl5')};
  display: flex;
  flex-direction: column;

  @media (min-width: ${screen('lg')}) {
    margin-left: -${spacing('xl5')};
    margin-right: -${spacing('xl5')};
    flex-direction: row;
    gap: ${spacing('xl2')};
  }

  > :first-child {
    max-width: 22rem;
    width: 100%;
    flex-shrink: 0;
  }

  ${StyledAnchor} {
    margin-left: 0;
  }
`;

export const StyledChart = styled.div`
  flex-grow: 1;
`;
